import Modal from './accessibility';
// import Dom from '../Utility/Dom'; // Doesn't work with Turbo
import {debouncer, documentReady} from '../Utility/utils';


documentReady(event => {
  const Dom = {
      'body'              : document.getElementsByTagName("body")[0],

      // accesibility
      'focusable'         : document.querySelectorAll("a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), object, embed, *[tabindex], *[contenteditable], *[data-notab]"),

      // Modal
      'modalTrigger'      : document.querySelectorAll('[modal-target]'),
      'closeModal'        : document.querySelectorAll('.modal__close'),
      'closeAnyModal'     : document.querySelectorAll('[data-dismiss="allModal"]'),
      'closeButton'       : document.querySelectorAll('[close-button]'),
  }


  // Modal Open
  // Dom.modalTrigger.forEach(item => {
  //   item.addEventListener('click', modalOpen);
  //   item.addEventListener('keypress', modalOpen);
  // });
  document.addEventListener('click', function(e) {
    if (e.target.matches('[modal-target]') || !!e.target.closest('[modal-target]')) {
      modalOpen(e);
    }
  });
  document.addEventListener('keypress', function(e) {
    if (e.target.matches('[modal-target]') || !!e.target.closest('[modal-target]')) {
      modalOpen(e);
    }
  });

  // In the event a modal link is added without the modal-target attr, try to check if it's got a modal id as an href attr.
  document.addEventListener('click', function(e){
    if (e.target.matches('a') || !!e.target.closest('a')) {
      const href = e.target.matches('a') ? e.target.getAttribute('href') : e.target.closest('a').getAttribute('href');
      if (/^#/.test(href)) {
        const hash = href.substring(href.indexOf("#"));
        const hashTarget = document.getElementById(hash.substring(1));
        if (hash !== "#" && hashTarget && hashTarget.classList.contains('modal')) {
          modalOpen(e, hashTarget);

          // if it's the admin area, ensure the modal is sized correctly.
          set_admin_modal_css();
        }
      }
    }
  });

  function modalOpen(e, modalEl = false){
    e.preventDefault();
    const el = e.target.matches('a') || e.target.matches('button') ? e.target : e.target.closest('a') || e.target.closest('button');
    if(e.type === 'click' || e.key === 'Enter' ){
      const target = modalEl ? modalEl : document.getElementById(el.getAttribute('modal-target'));
      if(!target){
        return;
      }

      target.classList.add('opening');
      target.classList.add('active');
      target.setAttribute('aria-hidden', 'false');
      target.setAttribute('tabindex','1');

      Dom.body.classList.add('scroll-lock');
      Dom.body.classList.add('modal-active');

      setTimeout(function(){
        target.classList.remove('opening');
      }, 1);

      // Handles trapping focus in modal
      Modal.open(target);

      // add active class to body
      const body = document.querySelector('body');
      if(!body.classList.contains('wp-admin')){
        body.classList.add('modal-active');
      }

      const iframes = target.querySelectorAll('iframe');
      const lazyLoadTrigger = target.querySelector('.lazy-load-youtube.preview-lazyload.preview-youtube');

      if (iframes.length) {
        iframes[0].src += '&autoplay=1';
      }
      else if(!!lazyLoadTrigger){
        var event = new Event('click');
        lazyLoadTrigger.dispatchEvent(event);
      }
    }
  }


  // Modal Close
  document.addEventListener('click', function(e) {
    if (e.target.matches('.modal__close') || !!e.target.closest('.modal__close') || e.target.matches('.modal')) {
      modalClose(e);
    }
  });
  document.addEventListener('keypress', function(e) {
    if (e.target.matches('.modal__close') || !!e.target.closest('.modal__close') || e.target.matches('.modal')) {
      modalClose(e);
    }
  });

  function modalClose(e){
    if(e.key === 'Enter' || e.type === 'click'){
      e.preventDefault();
      let target = e.target.matches('.modal') ? e.target : e.target.closest('.modal');
      target.classList.add('closing');

      setTimeout(function(){
        target.setAttribute('aria-hidden', 'true');
        target.setAttribute('tabindex','-1');
        Dom.body.classList.remove('scroll-lock');
        Dom.body.classList.remove('modal-active');
        target.classList.remove('active');
        target.classList.remove('closing');
      }, 300);

      // Handles un-trapping focus in modal
      Modal.close(target);

      // remove active class to body
      const body = document.querySelector('body');
      if(body.classList.contains('modal-active')){
        body.classList.add('modal-active');
      }

      if (target.querySelectorAll('iframe').length) {
        // reset the iframe src to stop iframe playing
        var _modalFrame = target.querySelectorAll('iframe');
        var src = _modalFrame[0].getAttribute('src');

        var newsrc = src.replace('&autoplay=1', '');
        newsrc = newsrc.replace('?autoplay=1&', '?');
        _modalFrame[0].setAttribute('src', newsrc);
      }
    }
  };


  // ADMIN SECTION - HELP ADMIN EDITOR LAYOUT
  const body = document.getElementsByTagName("body")[0];

  function set_admin_modal_css(){
    if(body.classList.contains('block-editor-page')){
      let counterCheck = 0;

      // Because block editor markup isn't immediately loaded when the page is loaded, we may have to check multiple times.
      let checkForContentArea = setInterval(function(){
        counterCheck++;

        const contentArea = document.querySelector('.interface-interface-skeleton__content');

        // contenArea is found
        if(counterCheck > 20 || contentArea){
          // clear the interval
          clearInterval(checkForContentArea);

          // get css values needed from content area
          const contentWidth = contentArea.clientWidth;
          const contentLeft = contentArea.getBoundingClientRect().left;

          // set width on all modals
          const modals = document.querySelectorAll('.modal');
          modals.forEach(item => {
            item.style.width = contentWidth + 'px';
            item.style.left = contentLeft + 'px';
          });
        }
      }, 50);
    }
  }
  set_admin_modal_css();

  // Resize modals on window resize
  window.addEventListener('resize', debouncer(function(){
    set_admin_modal_css();
  }, 15));

  // Resize modals when editor ui changes (fullscreen mode change or right sidebar show/hide)
  document.addEventListener('click', function(e){
    if(e.target.matches('button') || !!e.target.closest('button')){
      const button = e.target.matches('button') ? e.target : e.target.closest('button');
      if(!!button.closest('.edit-post-header__settings') || !!button.closest('.components-dropdown-menu__menu')){
        setTimeout(function(){
          set_admin_modal_css();
        }, 100);
      }
    }
  });

  // Add modal ID to the instructions in the block editor panel, showing how to link to the modal in another button if needed.
  if(body.classList.contains('block-editor-page')){
    document.addEventListener('click', function(e){
      const selected_block = document.querySelector('.wp-block.is-selected');
      if(!!selected_block){
        const modal = selected_block.querySelector('.modal');
        if(modal && !e.target.closest('.acf-block-panel')){
          const modal_id = modal.getAttribute('id');

          let checkForInstructions = setInterval(function(){
            const modalInstructionID = document.querySelector('.modal_block_id');

            // ID span found
            if(modalInstructionID){
              // clear the interval
              clearInterval(checkForInstructions);

              // Add the ID.
              modalInstructionID.innerHTML = modal_id;
            }
          }, 50);
        }
      }
    });
  }
});
